import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from 'react';
import { PatientPortalSystemOptions } from 'types/patient-portal-system.types';
import { usePPSystemId } from 'hooks/use-pp-system-id/use-pp-system-id.hook';

interface PatientPortalContextProps {
  systemId: PatientPortalSystemOptions;
  setSystemId: React.Dispatch<React.SetStateAction<PatientPortalSystemOptions>>;
}

const PatientPortalContext = createContext<
  PatientPortalContextProps | undefined
>(undefined);

export const PatientPortalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const ppId = usePPSystemId();
  const [systemId, setSystemId] = useState<PatientPortalSystemOptions>(ppId);

  const value = useMemo(
    () => ({
      systemId,
      setSystemId,
    }),
    [systemId],
  );

  return (
    <PatientPortalContext.Provider value={value}>
      {children}
    </PatientPortalContext.Provider>
  );
};

export const usePatientPortalContext = () => {
  const context = useContext(PatientPortalContext);
  if (!context) {
    throw new Error(
      'usePatientPortalContext must be used within a PatientPortalProvider',
    );
  }
  return context;
};
